import React from 'react';
import PropTypes from 'prop-types';
import '../LyriaPay.css';
import '../ExpandButton.css';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { PAYMENT_METHOD_ICON_COMPONENT_MAPPING } from '../PaymentMethodIcon.js';
import axios from 'axios';

const Ingenico = React.forwardRef(
    (
        {
            config,
            token,
            lyriaUrl,
            paymentMethods
        },
        ref
    ) => {
        const { t } = useTranslation();

        React.useImperativeHandle(ref, () => ({
            pay() {
                let urlToRedirect = config.no_card_hosted_checkout_url;
                if (config.saved_payment_methods_config && config.saved_payment_methods_config.length > 0) {
                    urlToRedirect = config.saved_payment_methods_config[0].url;
                }
                processPayment(urlToRedirect);
            }
        }));

        const processPayment = (urlToRedirect) => {
            axios({
                method: 'post',
                url: lyriaUrl + '/ingenico/process',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {
                    request_token: token,
                    psp: config.id,
                }
            })
                .then(function ({data}) {
                    window.parent.location.href = urlToRedirect;
                })
                .catch(function (error) {
                });
        };

        const paymentMethod = (payment_method) => {
            const Component = PAYMENT_METHOD_ICON_COMPONENT_MAPPING[payment_method];
            return <Component key={payment_method} className="wz-lyriapay-expandbutton-icon" />;
        };

        const savedCards = config.saved_payment_methods_config && config.saved_payment_methods_config.length > 0 ? config.saved_payment_methods_config.map((spmc) => (
            <div className="wz-lyriapay-expandbutton" key={spmc.uuid} onClick={() => processPayment(spmc.url)}>
                <div className='wz-lyriapay-expandbutton-labels'>
                    {spmc.card_type} {spmc.masked_number}
                </div>
                <div className='wz-lyriapay-expandbutton-icons-single'>
                    {paymentMethod(spmc.card_type)}
                </div>
            </div>
        )): [];

        return (
            <>
                {config.saved_payment_methods_config.length > 0 && (
                    savedCards
                )}
                <div className="wz-lyriapay-expandbutton" onClick={() => processPayment(config.no_card_hosted_checkout_url)}>
                    <div className='wz-lyriapay-expandbutton-labels'>
                        {t('useNewPaymentMethod')}
                    </div>
                    <div
                        className={
                            cn(
                                'wz-lyriapay-expandbutton-icons',
                                {'wz-lyriapay-expandbutton-icons-single': paymentMethods.length === 1}
                            )
                        }
                    >
                        {paymentMethods
                            .filter(p => p.payment_method in PAYMENT_METHOD_ICON_COMPONENT_MAPPING)
                            .map(p => {
                                const Component = PAYMENT_METHOD_ICON_COMPONENT_MAPPING[p.payment_method];
                                return <Component key={p.payment_method} className="wz-lyriapay-expandbutton-icon" />;
                            })
                        }
                    </div>
                </div>

            </>
        );
    }
);

Ingenico.propTypes = {
    config: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    lyriaUrl: PropTypes.string.isRequired,
    paymentMethods: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        payment_method: PropTypes.string.isRequired,
    })).isRequired,
};

Ingenico.displayName = 'Ingenico';

export default Ingenico;

